import type { LayerDto } from 'cadenza/api-client/dto/layer-dto';

/** @see net.disy.cadenza.workbook.map.web.layer.dto/WorkbookGroupLayerDto.java */
export interface WorkbookGroupLayerDto extends LayerDto {
  layers: LayerDto[];
}

export function isWorkbookGroupLayerDto (layer: LayerDto): layer is WorkbookGroupLayerDto {
  return Object.keys(layer).includes('layers');
}
